var map = {
	"./CaseNoteIcon.svg": 3921,
	"./LegalMatterIcon.svg": 5698,
	"./SetupHeader.png": 9127,
	"./activitiesIcon.svg": 2297,
	"./activitiesWhite.svg": 684,
	"./addIcon.svg": 4650,
	"./addNewIcon.svg": 6831,
	"./addNewWhite.svg": 9169,
	"./addWhite.svg": 4507,
	"./addressIcon.svg": 3358,
	"./addressWhite.svg": 3718,
	"./app4legallogo.gif": 4157,
	"./attachmentsIcon.svg": 1658,
	"./attachmentsWhite.svg": 1554,
	"./audit.svg": 3048,
	"./authorization.png": 5810,
	"./automatedRule.svg": 8670,
	"./automatedRule.svg.bak": 4273,
	"./blank.svg": 7414,
	"./commonCaseIcon.svg": 8673,
	"./commonCaseWhite.svg": 6012,
	"./companyIcon.svg": 9167,
	"./companyWhite.svg": 4122,
	"./contact.png": 8125,
	"./contactIcon.svg": 8814,
	"./contactSupportIcon.svg": 1741,
	"./contactSupportWhite.svg": 4502,
	"./contactWhite.svg": 5230,
	"./contractIcon.svg": 466,
	"./contractNoteIcon.svg": 4691,
	"./contractNoteWhite.svg": 1271,
	"./contractWhite.svg": 886,
	"./corporateMatterIcon.svg": 4694,
	"./corporateMatterWhite.svg": 2332,
	"./critical.png": 9268,
	"./customer-service.svg": 8403,
	"./database.svg": 2947,
	"./documentation-new.svg": 3817,
	"./editExistedOneIcon.svg": 6988,
	"./editExistedOneWhite.svg": 5063,
	"./email.svg": 9168,
	"./errorZ.svg": 9129,
	"./excel.svg": 856,
	"./expenseIcon.svg": 66,
	"./expenseWhite.png": 855,
	"./expenseWhite.svg": 7123,
	"./fail.png": 1964,
	"./folders.svg": 5331,
	"./gmail.svg": 1716,
	"./hearingIcon.svg": 8092,
	"./hearingWhite.svg": 4152,
	"./high.png": 7841,
	"./html.svg": 5929,
	"./insurance.svg": 4887,
	"./intellectualPropertyIcon.svg": 9548,
	"./intellectualPropertyWhite.svg": 4407,
	"./ipIcon.svg": 4943,
	"./judged-no.svg": 3051,
	"./judged-yes.svg": 8126,
	"./languages-new.svg": 6771,
	"./license-new.svg": 4787,
	"./litigationCaseIcon.svg": 5387,
	"./litigationCaseWhite.svg": 878,
	"./litigationIcon.svg": 7802,
	"./litigationWhite.svg": 7147,
	"./loader.gif": 6082,
	"./log-file.svg": 3825,
	"./logAsIcon.svg": 7915,
	"./logAsWhite.svg": 8471,
	"./logTime.svg": 1162,
	"./logTimeIcon.svg": 6522,
	"./logTimeWhite.svg": 1341,
	"./logo-filled.png": 2298,
	"./logout-new.svg": 582,
	"./logout.png": 6645,
	"./logs-new.svg": 5695,
	"./low.png": 1011,
	"./mail-new.svg": 947,
	"./mailapp.svg": 694,
	"./matterNoteIcon.svg": 1693,
	"./matterNoteWhite.svg": 8158,
	"./medium.png": 6401,
	"./meetingIcon.svg": 4955,
	"./meetingWhite.svg": 6000,
	"./microsoft-logo.png": 6706,
	"./microsoft.svg": 1136,
	"./moreFieldsIcon.svg": 3362,
	"./moreFieldsWhite.svg": 5054,
	"./noActivities.svg": 5572,
	"./noActivitiesnoMicrosoft.svg": 1901,
	"./noteIcon.svg": 8765,
	"./noteWhite.svg": 4119,
	"./office.svg": 6063,
	"./outlook.svg": 2849,
	"./outlookpeople.png": 3797,
	"./paint-new.svg": 3775,
	"./pdf.svg": 7575,
	"./picture.svg": 8306,
	"./powerpoint.svg": 8324,
	"./preferences-new.svg": 5921,
	"./refresh.svg": 1431,
	"./settingsIcon.png": 8307,
	"./settingsIcon.svg": 2099,
	"./settingsWhite.svg": 2934,
	"./success.svg": 8371,
	"./successZ.svg": 7360,
	"./support-new.svg": 9991,
	"./syncContacts.svg": 9208,
	"./syncContactsIcon.svg": 3219,
	"./syncContactsWhite.svg": 1047,
	"./system-update.svg": 8411,
	"./taskIcon.svg": 3500,
	"./taskWhite.svg": 9242,
	"./theme.svg": 8035,
	"./tools.svg": 6103,
	"./translation.svg": 9327,
	"./unverified-hearing.svg": 5292,
	"./verified-hearing.svg": 2775,
	"./warning.svg": 19,
	"./word.svg": 2135,
	"./zoom_auth.png": 560
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;